import theme from 'styled-theming'
import light from './light'
import dark from './dark'
export const bg_color1 = theme('mode', {
  light: light.bg_color1,
  dark: dark.bg_color1
})

export const bg_color2 = theme('mode', {
  light: light.bg_color2,
  dark: dark.bg_color2
})

export const color1 = theme('mode', {
  light: light.color1,
  dark: dark.color1
})

export const color2 = theme('mode', {
  light: light.color2,
  dark: dark.color2
})

export const border_color = theme('mode', {
  light: light.border_color,
  dark: dark.border_color
})

export const bg_color = theme('mode', {
  light: light.bg_color,
  dark: dark.bg_color
})
export const tab_bg_color = theme('mode', {
  light: light.tab_bg_color,
  dark: dark.tab_bg_color
})

export const text_clolor = theme('mode', {
  light: light.text_clolor,
  dark: dark.text_clolor
})

export const toast_bg_color = theme('mode', {
  light: light.toast_bg_color,
  dark: dark.toast_bg_color
})

export const toast_text = theme('mode', {
  light: light.toast_text,
  dark: dark.toast_text
})

export const card_bg_color = theme('mode', {
  light: light.card_bg_color,
  dark: dark.card_bg_color
})

export const active_bg_color = theme('mode', {
  light: light.active_bg_color,
  dark: dark.active_bg_color
})

export const activity_state_color = theme('mode', {
  light: light.activity_state_color,
  dark: dark.activity_state_color
})

export const no_data_img = theme('mode', {
  light: light.nodata_img,
  dark: dark.nodata_img
})


export const box_shadow = theme('mode', {
  light: light.box_shadow,
  dark: dark.box_shadow
})

export const invite_bg = theme('mode', {
  light: light.invite_bg,
  dark: dark.invite_bg
})

export const invite_text = theme('mode', {
  light: light.invite_text,
  dark: dark.invite_text
})

export const invite_card_bg = theme('mode', {
  light: light.invite_card_bg,
  dark: dark.invite_card_bg
})
export const ellipsis_color = theme('mode', {
  light: light.ellipsis_color,
  dark: dark.ellipsis_color
});
export const loading_img = theme('mode', {
  light: light.loading_img,
  dark: dark.loading_img
});

